import { Icon } from "@circle-react-shared/Icon";
import { Button as CompassButton } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { BaseConnectionButtonProps } from "./types";

const sizeClasses = {
  sm: "!h-7 !px-3 gap-1",
  md: "!h-8 !px-4 gap-1.5",
  lg: "!h-10 !px-5 gap-2",
  full: "w-full",
};

const iconSizes = {
  sm: 16,
  md: 20,
  lg: 22,
  full: 16,
};

export const ConnectedButton = ({
  className,
  compassClassName,
  size = "md",
  fullWidth = false,
}: BaseConnectionButtonProps) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <CompassButton
        variant="secondary"
        startIcon="checkmark"
        disabled
        data-testid="connected-button"
        fullWidth={fullWidth}
        className={compassClassName}
      >
        {t("profile_drawer.connect_banner.states.active")}
      </CompassButton>
    );
  }

  const sizeClass = sizeClasses[size];
  const iconSize = iconSizes[size];
  return (
    <Button
      variant="secondary"
      disabled
      large={size === "lg"}
      className={classNames(
        "flex items-center gap-x-2 min-w-30",
        sizeClass,
        className,
      )}
      data-testid="connected-button"
    >
      <Icon type="20-checkmark" size={iconSize} useWithFillCurrentColor />
      {t("profile_drawer.connect_banner.states.active")}
    </Button>
  );
};
